import OrderSummaryLazyLoader from '../../OrderSummary/OrderSummaryLazyLoader';
import CheckoutOverlay from '../CheckoutOverlay';

function OrderSummaryOverlay() {
  return (
    <CheckoutOverlay popup ordersummary nopadding title="checkout.order.summary.section.heading.text">
      <OrderSummaryLazyLoader isOverlay />
    </CheckoutOverlay>
  );
}

export default OrderSummaryOverlay;
